/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HttpTestReq } from '../../models/http-test-req';

export interface ApiServerTestRestHttpTestPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: HttpTestReq
}

export function apiServerTestRestHttpTestPost(http: HttpClient, rootUrl: string, params?: ApiServerTestRestHttpTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiServerTestRestHttpTestPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiServerTestRestHttpTestPost.PATH = '/api/server-test/rest-http-test';
